import { render, staticRenderFns } from "./UserSaleStatementList.vue?vue&type=template&id=2ccadca0&scoped=true"
import script from "./UserSaleStatementList.vue?vue&type=script&lang=js"
export * from "./UserSaleStatementList.vue?vue&type=script&lang=js"
import style0 from "./UserSaleStatementList.vue?vue&type=style&index=0&id=2ccadca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccadca0",
  null
  
)

export default component.exports